import { Stack, Box, Typography, useTheme } from '@mui/material';
import React from 'react';

import styles from './LiveWindLineGraph.module.scss';

interface Props {}

const LiveWindGraphLegend: React.FC<Props> = () => {
  const theme = useTheme();
  return (
    <Stack
      className={styles.liveWindGraphLegend}
      data-testid="live-wind-line-graph-legend"
      direction="row"
      alignItems="center"
    >
      <Stack direction="row" alignItems="center">
        <Stack direction="row" className={styles.observedLegendBox} alignItems="center">
          <Box
            className={styles.observedLegendBoxColor}
            sx={{
              background: theme.conditions.poor,
              borderRadius: '1px 0px 0px 1px',
            }}
          />
          <Box
            className={styles.observedLegendBoxColor}
            sx={{ background: theme.conditions.poorToFair }}
          />
          <Box
            className={styles.observedLegendBoxColor}
            sx={{ background: theme.conditions.fair }}
          />
          <Box
            className={styles.observedLegendBoxColor}
            sx={{ background: theme.conditions.good, borderRadius: '0px 1px 1px 0px' }}
          />
        </Stack>
        <Typography
          variant="caption2"
          color="text.brandSecondary"
          className={styles.legendText}
          sx={{ mr: '9px' }}
        >
          Observed
        </Typography>
        <Box className={styles.forecastedLegendBox} />
        <Typography variant="caption2" color="text.brandSecondary" className={styles.legendText}>
          Forecasted
        </Typography>
      </Stack>
    </Stack>
  );
};

export default LiveWindGraphLegend;
